<template>
    <div id="list-view" class="border relative">
        <div class="w-full pb-2">
            <div class="flex md:items-end items-center justify-between flex-wrap">
                    <feather-icon
                        v-if="showSideBar"
                        class="inline-flex lg:hidden cursor-pointer mr-4"
                        icon="MenuIcon"
                        @click.stop="openSideBar" />
                <p class="lg:inline-flex" v-if="showSideBar">Filtros</p>

                <div class="flex justify-between items-end flex-grow">
                    <!-- Stats -->
                    <div>
                        <p class="total font-semibold md:block hidden" :style="{marginLeft:showSideBar ? '18rem' : ''}">
                            <slot name="options-totalizer"></slot>
                        </p>
                    </div>

                    <div class="flex flex-wrap">
                        <!-- Add other filters here !-->
                    </div>
                </div>
            </div>
        </div>
        <div id="list-view-container" class="relative clearfix">
            <vs-sidebar class="items-no-padding vs-sidebar-rounded background-absolute" parent="#list-view-container" :click-not-close="true" :hidden-background="true" v-model="isFilterSidebarActive">
                <VuePerfectScrollbar class="scroll-area" :settings="settings">
                    <div class="p-6 filter-container  app-fixed-height">
                        <div class="flex justify-center">
                            <slot name="sidebar-header">
                                <!-- Sidebar Header !-->
                            </slot>
                        </div>
                        <vs-divider v-show="!!$slots['sidebar-header']"/>
                        <div>
                            <slot name="sidebar-body">
                                <!-- Sidebar body !-->
                            </slot>
                        </div>
                        <vs-divider v-show="!!$slots['sidebar-body']"/>
                        <div class="flex justify-center" v-show="!!$slots['sidebar-body']">
                            <slot name="sidebar-footer">
                                <!-- Sideebar Footer !-->
                            </slot>
                        </div>
                    </div>
                </VuePerfectScrollbar>
            </vs-sidebar>

            <div :class="{'sidebar-spacer-with-margin': isFilterSidebarActive && showSideBar}" class="app-fixed-height">
                <slot name="container-header">
                    <div class="relative mb-8">
                        <!-- SEARCH INPUT -->
                        <vs-input icon-pack="feather" class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg" placeholder="Pesquisar" v-model="search" size="large" @input="searching"/>

                        <!-- SEARCH ICON -->
                        <div slot="submit-icon" class="absolute pin-t pin-r py-4 px-6" v-show="!onSearch">
                            <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" />
                        </div>

                        <!-- CLEAR INPUT ICON -->
                        <div slot="reset-icon" class="absolute pin-t pin-r py-4 px-6" v-show="onSearch">
                            <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer"/>
                        </div>
                    </div>
                </slot>

                <div class="flex flex-col container-list-height overflow-auto relative">
                    <div class="vs-con-loading__container absolute h-full w-full z-max" v-show="onLoad" id="loading"></div>
                    <slot name="container-body">

                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {mapGetters} from 'vuex'
export default {
    components:{
        VuePerfectScrollbar
    },
    props: {
        totalItems: Number,
        onLoad: Boolean,
        showSideBar: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isFilterSidebarActive: false,
            onSearch: false,
            search: '',
            settings:{
                maxScrollbarLength: 60,
                wheelSpeed: 0.30
            }
        }
    },

    computed: {
        ...mapGetters(["isMobile"])
    },

    methods: {
        handleWindowResize() {
            this.isFilterSidebarActive = !this.isMobile &&  this.showSideBar;
        },
        searching (value) {
            this.$emit("searching", value);
        },

        openSideBar () {
            this.isFilterSidebarActive = !this.isFilterSidebarActive && this.showSideBar;
        }
    },

    mounted () {
        this.isFilterSidebarActive = !this.isMobile && this.showSideBar;
        this.$vs.loading({
            type: 'default',
            scale: '0.5',
            container: '#loading'
        });
        window.addEventListener('resize', (evt) => {
            this.handleWindowResize();
        });
    }
}
</script>

<style lang="scss" scoped>
    .sidebar-spacer-with-margin {
        width: calc(100% - 260px - 2.2rem);
        margin-left: calc(260px + 2.2rem);
    }

    .container-list-height {
        height: calc(100vh - 20.1rem);
    }
</style>
